import { VoidPaymentDetail } from "./void-payment-detail";

export class VoidPayment {
    documents: string;
    contracts: string;
    customerCode: string;
    customerName: string;
    amount: number;
    currency: string;
    date: string;
    receiptCode: string;
    returnReceipt: string;
    details: Array<VoidPaymentDetail>
    groupingNo: string;
    salesOrg: string;
    invoiceCode: string;
    constructor() {
        this.documents = "";
        this.contracts = "";
        this.customerCode = "";
        this.customerName = "";
        this.amount = 0.0;
        this.currency = "";
        this.date = "";
        this.receiptCode = "";
        this.returnReceipt = "";
        this.details = [];
        this.groupingNo = "";
        this.salesOrg = "";
        this.invoiceCode = "";
    }

}